import EpisodeTitle from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeTitle.vue";
import EpisodeCoverImage from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeCoverImage.vue";
import EpisodeDuration from "%/dynamic-component-editor/standard-components/episode-card-small/EpisodeDuration.vue";
import EpisodeNumber from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeNumber.vue";
import EpisodeUpvoteScore from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeUpvoteScore.vue";
import EpisodeLikeCount from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeLikeCount.vue";
import EpisodeCommentCount from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeCommentCount.vue";
import EpisodeShareCount from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeShareCount.vue";
import EpisodeSpotifyLink from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeSpotifyLink.vue";
import EpisodeApplePodcastsLink from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeApplePodcastsLink.vue";
import EpisodeYouTubeLink from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeYouTubeLink.vue";
import EpisodePocketcastsLink from "%/dynamic-component-editor/standard-pages/episode-page/EpisodePocketcastsLink.vue";
import EpisodeContent from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeContent.vue";
import EpisodeAuthor from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeAuthor.vue";
import EpisodeDescription from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeDescription.vue";
import EpisodeReleaseDate from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeReleaseDate.vue";
import SeasonNumber from "%/dynamic-component-editor/standard-pages/episode-page/SeasonNumber.vue";
import EpisodeDownvoteScore from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeDownvoteScore.vue";
import EpisodeCommentsWidget from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeCommentsWidget.vue";
import EpisodeVoteScore from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeVoteScore.vue";
import EpisodeLikeAction from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeLikeAction.vue";
import EpisodeShareAction from "%/dynamic-component-editor/standard-pages/episode-page/EpisodeShareAction.vue";
import EpisodeButton from "%/dynamic-component-editor/standard-components/episode-card-small/EpisodeButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyEpisode extends LegacyEntity {
  get elements() {
    return {
      EpisodeAuthor,
      EpisodeTitle,
      EpisodeDescription,
      EpisodeCoverImage,
      EpisodeDuration,
      EpisodeNumber,
      EpisodeReleaseDate,
      EpisodeContent,
      EpisodeVoteScore,
      EpisodeUpvoteScore,
      EpisodeDownvoteScore,
      EpisodeLikeCount,
      EpisodeLikeAction,
      EpisodeCommentCount,
      EpisodeCommentsWidget,
      EpisodeShareCount,
      EpisodeShareAction,
      // "Go To Episode" nav button (season card → episode page).
      EpisodeButton,
      EpisodeSpotifyLink,
      EpisodeApplePodcastsLink,
      EpisodeYouTubeLink,
      EpisodePocketcastsLink,
      SeasonNumber,
    };
  }
}
